import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import BigCLoading from "../components/Loading";
import { useParams } from "react-router-dom";
import Axios from "axios";

async function getCallData(menuType) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_DOMAIN_BIGLINE_API}/line-rich-menu-one-link/rich_active/${menuType}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_BIGLINE_X_API_KEY,
        },
      }
    );
    return result.data;
  } catch (error) {
    console.log(`bigline-cms: ${error}`);
  }
}

const LineRichmenuOneLink = () => {
  const { menuType, position } = useParams();

  useEffect(async () => {
    async function fetchData() {
      //const allPathName = window.location.pathname;
      //const pathName = allPathName.substring(13); // out --> /line-connect
      //const searchParam = window.location.search;
      //console.log(searchParam);
      //console.log(`menuType :  ${menuType}`);
      //console.log(`position :  ${position}`);
      if (menuType && position) {
        let actionLink = "";
        let actionType = "";
        let actionContent = "";
        const getRichMenus = await getCallData(menuType.toLowerCase());
        //console.log(getRichMenus);
        if (getRichMenus) {
          switch (position.toLowerCase()) {
            case "p1":
              actionLink = getRichMenus.actionLink01;
              actionType = getRichMenus.actionType01;
              actionContent = getRichMenus.actionContent01;
              break;
            case "p2":
              actionLink = getRichMenus.actionLink02;
              actionType = getRichMenus.actionType02;
              actionContent = getRichMenus.actionContent02;
              break;
            case "p3":
              actionLink = getRichMenus.actionLink03;
              actionType = getRichMenus.actionType03;
              actionContent = getRichMenus.actionContent03;
              break;
            case "p4":
              actionLink = getRichMenus.actionLink04;
              actionType = getRichMenus.actionType04;
              actionContent = getRichMenus.actionContent04;
              break;
            case "p5":
              actionLink = getRichMenus.actionLink05;
              actionType = getRichMenus.actionType05;
              actionContent = getRichMenus.actionContent05;
              break;
            case "p6":
              actionLink = getRichMenus.actionLink06;
              actionType = getRichMenus.actionType06;
              actionContent = getRichMenus.actionContent06;
              break;
            case "p7":
              actionLink = getRichMenus.actionLink07;
              actionType = getRichMenus.actionType07;
              actionContent = getRichMenus.actionContent07;
              break;
            case "p8":
              actionLink = getRichMenus.actionLink08;
              actionType = getRichMenus.actionType08;
              actionContent = getRichMenus.actionContent08;
              break;
          }
        }
        if (actionType === 'uri') {
          //URI LINK
          window.location.href = actionLink;
          /*console.log(`actionType :  ${actionType}`);
          console.log(`actionContent :  ${actionContent}`);
          console.log(`actionLink :  ${actionLink}`);*/
        }
        else{
          //message

          /*console.log(`actionType :  ${actionType}`);
          console.log(`actionContent :  ${actionContent}`);
          console.log(`actionLink :  ${actionLink}`);*/
          //window.location.href = actionLink;
        }
      }

      /*if (isMobile) {
        window.location.href = `line://app/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}${pathName}${searchParam}`;
      } else {
        window.location.href = `https://liff.line.me/${process.env.REACT_APP_LINE_CONNECT_LIFF_ID}${pathName}${searchParam}`;
      }*/
    }

    
    //   https://bigc-dmkt-link-stg.web.app/richmenu-onelink/member/p1
    //   localhost:3000/richmenu-onelink/member/p1
    //   localhost:3000/richmenu-onelink/default/p1

    fetchData();
  }, []);
  return <></>;
};

export default LineRichmenuOneLink;
